/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import {
  Grid,
  Form,
  Header,
  Button,
  Divider,
  Icon,
} from 'semantic-ui-react';
import CurrencySymbol from './CurrencySymbol';
import LoanAmount from './LoanAmount';
import { spaFullNumber } from '../utils/amount';
import { isPricingPackageLocked, vnPackageLockMessage } from '../utils/vietnamPricing';
import { isVietnamCompany } from '../utils/vietnam';
import { TRANSLATION_FILES } from '../constants/translation';
import config from '../../config';

const isPackagePricingRequired = config.get('isPackagePricingRequired');

class EditPackageModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    loading: PropTypes.bool,
    selectedPackagePricing: PropTypes.string,
    selectedCustomPPName: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
    auth: PropTypes.shape({
      company: PropTypes.shape({ countryCode: PropTypes.string }),
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
    }),
    packagePricings: PropTypes.arrayOf(PropTypes.shape()),
    isMobile: PropTypes.bool,
    bookingData: PropTypes.shape(),
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      bookingListItems: [],
      bookingSpaItems: [],
      currentBookingPackagePricing: {},
      isCurrentBookingPP: true,
      projectListItems: [],
      projectSpaItems: [],
      selectedPackagePricingItem: {},
      selection: '',
      disableBaseSellingPrice: props.bookingData && props.bookingData.project ? props.bookingData.project.disableBaseSellingPriceSelection : false,
    };
  }

  componentDidMount() {
    const { selectedPackagePricing, selectedCustomPPName } = this.props;
    if (selectedPackagePricing || selectedCustomPPName) {
      const selectedPP = selectedPackagePricing || selectedCustomPPName;
      this.handleSetSelectedPackagePricingItem(selectedPP, selectedCustomPPName !== '');
    }
  }

  getCalculationTypeClassname = (type) => {
    switch (type) {
      case 'subtotal':
        return 'subtotal';
      default:
        return 'itemRow';
    }
  }

  convertTextClass = (isSubtotal) => {
    if (isSubtotal) {
      return 'text-subtitle';
    }
    return 'text-item';
  }

  handleOnResetCalculationItems = (pp, isBooking = false) => {
    const isBookingPP = isBooking && pp && pp.calculations && pp.calculations.length > 0;
    const isProjectPP = !isBooking && pp && pp && pp.projectPackagePricing && pp.projectPackagePricing.packagePricingCalculations && pp.projectPackagePricing.packagePricingCalculations.length > 0;
    if (isBookingPP || isProjectPP) {
      const bookingCalculations = isBookingPP ? pp.calculations.filter(bc => bc.isEnabled) : [];
      const calculations = isBookingPP ? bookingCalculations : pp.projectPackagePricing.packagePricingCalculations;
      const listItems = calculations.filter(cc => cc.category === 'list_price');
      const spaItems = calculations.filter(cc => cc.category === 'spa_price');
      if (isBookingPP) {
        this.setState({ bookingListItems: listItems, bookingSpaItems: spaItems });
        this.setState({ projectListItems: [], projectSpaItems: [] });
      } else {
        this.setState({ projectListItems: listItems, projectSpaItems: spaItems });
        this.setState({ bookingListItems: [], bookingSpaItems: [] });
      }
    } else {
      this.setState({ bookingListItems: [], bookingSpaItems: [] });
      this.setState({ projectListItems: [], projectSpaItems: [] });
    }
  }

  handleSelectPackagePricing = (e, data) => {
    e.preventDefault();
    this.handleSetSelectedPackagePricingItem(data.value);
    this.setState({ selection: data.value });
  }

  handleSetSelectedPackagePricingItem = (selected, isDefaultCustom = false) => {
    const { bookingData, packagePricings } = this.props;
    if (selected) {
      if (selected === 'base_selling_price') {
        this.setState({
          isCurrentBookingPP: false,
          currentBookingPackagePricing: {},
          selectedPackagePricingItem: {
            spaPrice: bookingData.unitSellingPrice,
            totalPrice: bookingData.unitSellingPrice,
            listPrice: bookingData.unitSellingPrice,
          },
        });
        this.handleOnResetCalculationItems(null);
      } else if (packagePricings && packagePricings.length > 0) {
        const selectedPP = packagePricings.find(pp => pp.projectPackagePricingID === selected);
        const customPricePP = packagePricings.find(pp => (isDefaultCustom ? pp.customName === selected : pp.id === selected));
        if (selectedPP || customPricePP) {
          if (bookingData.packagePricing && bookingData.packagePricing.projectPackagePricingID === selected) {
            this.setState({
              isCurrentBookingPP: true,
              currentBookingPackagePricing: bookingData.packagePricing,
              selectedPackagePricingItem: {},
            });
            this.handleOnResetCalculationItems(bookingData.packagePricing, true);
          } else {
            const pp = selectedPP || customPricePP;
            this.setState({
              isCurrentBookingPP: false,
              currentBookingPackagePricing: {},
              selectedPackagePricingItem: pp,
            });
            if (customPricePP && customPricePP) {
              this.setState({ selection: customPricePP.id });
            }
            this.handleOnResetCalculationItems(pp);
          }
        } else if (bookingData && bookingData.packagePricingID) {
          // not in unit package pricing
          this.setState({
            isCurrentBookingPP: true,
            currentBookingPackagePricing: bookingData.packagePricing,
            selectedPackagePricingItem: {},
          });
          this.handleOnResetCalculationItems(bookingData.packagePricing, true);
        }
      } else {
        this.setState({
          isCurrentBookingPP: false,
          currentBookingPackagePricing: {},
          selectedPackagePricingItem: {},
        });
        this.handleOnResetCalculationItems(null);
      }
    }
  }

  handleSubmit = () => {
    const { selectedPackagePricingItem } = this.state;
    const { onSubmit, onClose } = this.props;
    if (onSubmit && selectedPackagePricingItem) {
      onSubmit(selectedPackagePricingItem);
    }
    onClose();
  };

  hasAccessNettSellingPrice(project) {
    const { auth } = this.props;
    if (auth.isSuperAdmin || auth.isHeadquarters) {
      return true;
    }
    if (project && project.accessBULNettSellingPrice && auth.isBranchLeader) {
      return true;
    }
    if (project && project.accessStaffNettSellingPrice && auth && auth.companyBranch) {
      return true;
    }
    return false;
  }

  filterPackagePricings = (packagePricings) => {
    const { bookingData } = this.props;
    const newPackagePricings = [...packagePricings];

    if (packagePricings && packagePricings.length > 0) {
      packagePricings.forEach((pp, idx) => {
        // Check for schedule dates if it's not a custom price
        if (!pp.isCustomPrice && pp.projectPackagePricing) {
          const sStart = pp.projectPackagePricing.scheduleStartAt;
          const sEnd = pp.projectPackagePricing.scheduleEndAt;

          // Check if package is expired based on schedule
          if ((sStart && moment(sStart).unix() > moment().unix()) ||
              (sEnd && moment(sEnd).unix() < moment().unix())) {
            newPackagePricings[idx] = { ...newPackagePricings[idx], disabled: true };
          } else if (pp.projectPackagePricing.bumiPurchaserOnly) {
            // Check bumi purchaser only restriction
            if (bookingData && bookingData.bookingCustomer.bumi === 'Bumiputera') {
              newPackagePricings[idx] = { ...newPackagePricings[idx], disabled: false };
            } else {
              newPackagePricings[idx] = { ...newPackagePricings[idx], disabled: true };
            }
          }
        }
      });
    }

    return newPackagePricings;
  }

  shapeOptions = (pp, bookingData) => {
    // Apply schedule date filtering first
    const filteredPP = pp ? this.filterPackagePricings(pp) : [];

    const baseSellingPriceItem = {
      value: 'base_selling_price',
      text: 'Base Selling Price',
      disabled: (isPackagePricingRequired && (filteredPP && filteredPP.length > 0)) || this.state.disableBaseSellingPrice,
      content: (
        <Header className="ddPricingTierItem">
          <div className="name">Base Selling Price</div>
        </Header>
      ),
    };
    const newPP = [baseSellingPriceItem];
    if (filteredPP || bookingData.packagePricingID) {
      filteredPP.forEach((d) => {
        const id = d.isCustomPrice ? d.id : d.projectPackagePricing.id;
        const optText = d.isCustomPrice ? d.customName : d.projectPackagePricing.name;
        const optDescp = d.isCustomPrice
          ? d.customDescription
          : d.projectPackagePricing.description;

        const newItem = {
          key: id,
          text: optText,
          description: optDescp,
          value: id,
          disabled: d.disabled || false,
          content: (
            <Header className="ddPricingTierItem">
              <div className="name">{optText}</div>
              <Header.Subheader>{optDescp}</Header.Subheader>
            </Header>
          ),
        };
        newPP.push(newItem);
      });
      if (bookingData.packagePricing) {
        const inPP = filteredPP.find(p => p.id === bookingData.packagePricingID);
        if (!inPP) {
          const text = bookingData.packagePricing.name || baseSellingPriceItem.text;
          const value = bookingData.packagePricing.projectPackagePricingID || baseSellingPriceItem.value;
          newPP.unshift({
            key: `npp_${value}`,
            text,
            description: bookingData.packagePricing.description,
            value,
            content: (
              <Header className="ddPricingTierItem">
                <div className="name">{text}</div>
                <Header.Subheader>{bookingData.packagePricing.description}</Header.Subheader>
              </Header>
            ),
          });
        }
      }
      // CPI-977 (PO, 14 Sep): a Vietnam booking always carries a named package, so Base
      // Selling Price is not offered here either - same rule as the reservation form.
      if (isVietnamCompany(this.props.auth)) {
        return newPP.filter(opt => opt.value !== 'base_selling_price');
      }
      return newPP;
    }
    return [];
  };

  renderFormulaChangeClass = (type) => {
    if (type.includes('deduct')) {
      return 'text_deduct';
    }
    if (type.includes('add')) {
      return 'text_add';
    }
    return '';
  };

  renderFormulaChangePrefix = (type) => {
    if (type.includes('deduct')) {
      return <Icon color="red" size="small" name="minus" />;
    }
    if (type.includes('add')) {
      return <Icon color="green" size="small" name="plus" />;
    }
    return '';
  };

  renderAmountWithCurrency = (amount, currency) => (
    <LoanAmount
      projectCurrencies={currency}
      format="0,000,000.00"
      amount={amount ? amount.toFixed(2) : '0.00'}
      prefix={<CurrencySymbol />}
    />
  );

  renderContent = (type, i, currency) => {
    const { isCurrentBookingPP } = this.state;
    const items = isCurrentBookingPP ? i : i.filter(c => c.applyToBooking);
    if (items && items.length > 0) {
      return (
        <div style={{ width: '100%' }}>
          <Grid columns={2} className="itemContents">
            {
              items.map(item => (
                <Grid.Row key={item.id} className={this.getCalculationTypeClassname(item.isSubTotal ? 'subtotal' : type)}>
                  <Grid.Column textAlign="left" width={9}>
                    <p className={`${this.convertTextClass(item.isSubTotal)}`}>
                      {
                        item.isSubTotal ? (
                          <span>
                            Sub total
                          </span>
                        ) : (
                          <span>
                            {isCurrentBookingPP ? item.name : item.projectPackagePricingItem.name}
                          </span>
                        )
                      }
                    </p>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={7}>
                    <p className={`${this.convertTextClass(item.isSubTotal)}`}>
                      <span className={`${this.renderFormulaChangeClass(isCurrentBookingPP ? item.calculationType : item.projectPackagePricingItem.calculationType)}`}>
                        {this.renderFormulaChangePrefix(isCurrentBookingPP ? item.calculationType : item.projectPackagePricingItem.calculationType)}&nbsp;
                        {this.renderAmountWithCurrency(item.isSubTotal ? item.newValue : item.valueChange, currency)}
                      </span>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              ))
            }
          </Grid>
        </div>
      );
    }
    return null;
  }

  renderPriceBreakdown = ({
    listPrice,
    currency,
  }) => {
    const { bookingData } = this.props;
    const {
      bookingListItems,
      bookingSpaItems,
      currentBookingPackagePricing,
      isCurrentBookingPP,
      projectListItems,
      projectSpaItems,
      selectedPackagePricingItem,
    } = this.state;
    let spaValue = 0;
    let nettValue = 0;
    const listItems = isCurrentBookingPP ? bookingListItems : projectListItems;
    const spaItems = isCurrentBookingPP ? bookingSpaItems : projectSpaItems;
    if (isCurrentBookingPP && currentBookingPackagePricing && currentBookingPackagePricing.id) {
      spaValue = currentBookingPackagePricing.spaPrice;
      nettValue = currentBookingPackagePricing.totalPrice;
    } else if (!isCurrentBookingPP && selectedPackagePricingItem) {
      spaValue = selectedPackagePricingItem.spaPrice;
      nettValue = selectedPackagePricingItem.totalPrice;
    } else if (bookingData) {
      spaValue = parseFloat(spaFullNumber(bookingData));
      nettValue = bookingData.nettSellingPrice;
    }
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <p className="text-title">List price</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="text-title">
              {this.renderAmountWithCurrency(listPrice, currency)}
            </p>
          </Grid.Column>
        </Grid.Row>
        <Divider />
        {
          listItems.length > 0 || spaItems.length > 0 ? (
            <Grid.Row className="packageFormula">
              <Grid.Column width={12}>
                <p className="text-title">Package formula</p>
              </Grid.Column>
            </Grid.Row>
          ) : (
            <Grid.Row>
              <Grid.Column>
                <p className="text-title">Package formula</p>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <p className="text-title">
                  N/A
                </p>
              </Grid.Column>
            </Grid.Row>
          )
        }
        {this.renderContent('list', listItems, currency)}
        <Divider style={{ width: '100%' }} />
        <Grid.Row className="packageFormula">
          <Grid.Column>
            <p className="text-title">SPA value</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="text-title">
              {this.renderAmountWithCurrency(spaValue, currency)}
            </p>
          </Grid.Column>
        </Grid.Row>
        {this.renderContent('spa', spaItems, currency)}
        {this.hasAccessNettSellingPrice(bookingData.project) && <Divider />}
        {
          this.hasAccessNettSellingPrice(bookingData.project) && nettValue && (
            <Grid.Row className="totalPrice">
              <Grid.Column>
                <p className="text-title">Nett selling price</p>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <p className="text-title">
                  {this.renderAmountWithCurrency(nettValue, currency)}
                </p>
              </Grid.Column>
            </Grid.Row>
          )
        }
      </Grid>
    );
  }

  render() {
    const {
      bookingData,
      isMobile,
      loading,
      packagePricings,
      selectedPackagePricing,
    } = this.props;
    const {
      selectedPackagePricingItem,
      selection,
    } = this.state;
    const noChanges = !selection || selection === selectedPackagePricing;
    // CPI-977 (PO, 14 Sep): Vietnam sees the dropdown only - no price breakdown column and no
    // pointer to the formula editor, which is hidden on the Sales Info card as well.
    const vnDropdownOnly = isVietnamCompany(this.props.auth);
    // CPI-977 requirements 7/11: belt and braces - the modal is also reachable by a deep link.
    if (isPricingPackageLocked(this.props.auth, bookingData && bookingData.statusID)) {
      const { t } = this.props;
      return (
        <section className="edit_package_pricing">
          <p className="text-body">
            <Icon name="lock" />
            {t(vnPackageLockMessage(this.props.auth, bookingData && bookingData.statusID))}
          </p>
        </section>
      );
    }
    return (
      <section className="edit_package_pricing">
        <Grid columns={isMobile || vnDropdownOnly ? 1 : 2}>
          <Grid.Row>
            <Grid.Column className="ppSelection">
              {!vnDropdownOnly && (
                <p className="text-body">
                  If you wish to edit Formula Items in the Package, please select the right package, save, exit and choose Customise formula(s)
                </p>
              )}
              <p className="text-subtitle">
                Pricing package&nbsp;
                <span style={{ color: 'red' }}>*</span>
              </p>
              <Form.Select
                className="ddPricingTierDropdown"
                options={this.shapeOptions(packagePricings, bookingData)}
                value={selection || selectedPackagePricing}
                selection
                fluid
                onChange={this.handleSelectPackagePricing}
                noResultsMessage="No pricing package found."
                placeholder="Select Pricing Package"
              />
            </Grid.Column>
            {!vnDropdownOnly && (
              <Grid.Column>
                <div className="packagePricingBreakdown">
                  {this.renderPriceBreakdown({
                    listPrice: bookingData.unitSellingPrice,
                    currency: bookingData.project.projectCurrency,
                  })}
                </div>
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column textAlign="right">
              <Button
                content="Save Package"
                disabled={noChanges && (!selectedPackagePricingItem || !selectedPackagePricingItem.id)}
                loading={loading}
                className="submit-button text-title"
                onClick={this.handleSubmit}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </section>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(EditPackageModal);



// WEBPACK FOOTER //
// ./src/components/EditPackageModal.jsx